import { render, staticRenderFns } from "./uploadIconDark.vue?vue&type=template&id=27d83591&"
import script from "./uploadIconDark.vue?vue&type=script&lang=js&"
export * from "./uploadIconDark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports